export default "__VITE_ASSET__GZndNQ$R__"